import React from 'react';
import '../TabNotificationRow.scss';
import './TabNotificationRowModeration.scss';
import '../../TabAppealAnswer/TabAppealAnswer.scss';
import { Appeal } from '../../../model/Appeal';
import TabAppealAnswer from '../../TabAppealAnswer/TabAppealAnswer';

interface TabNotificationRowDirectorProps {
  appeal: Appeal;
}

const TabNotificationRowDirector = (
  props: TabNotificationRowDirectorProps
): JSX.Element => {
  return <TabAppealAnswer appealId={props.appeal.id} />;
};

export default TabNotificationRowDirector;
